import { Skeleton } from "antd"
import React from "react"

import {
  RecordLoadFailed,
  RecordNotFound
} from "../../../components/RecordNotFound/RecordNotFound.tsx"
import { RoutesPaths } from "../../../constants/routes.ts"
import { type ProjectState } from "../redux/project.types.ts"

interface ProjectNotLoadedProps {
  id: string
  loadError: ProjectState["loadError"]
  onRetry: () => void
}

/**
 * What a project page shows while it has no project: a skeleton until this
 * id's read has answered, "not found" only for a 404, and a retry for any
 * other failure.
 */
export function ProjectNotLoaded({
  id,
  loadError,
  onRetry
}: ProjectNotLoadedProps) {
  if (!loadError || loadError.id !== id) {
    return <Skeleton.Node active className={"size-full"} />
  }

  if (loadError.notFound) {
    return (
      <RecordNotFound
        titleKey={"recordNotFound.project.title"}
        backTo={RoutesPaths.project.list}
        backLabelKey={"recordNotFound.project.back"}
      />
    )
  }

  return (
    <RecordLoadFailed
      onRetry={onRetry}
      backTo={RoutesPaths.project.list}
      backLabelKey={"recordNotFound.project.back"}
    />
  )
}
